import {
  MainFooterButton,
  FooterCounterWrapper,
  MainFooterText,
  MainFooterWrapper,
  CounterButtonWrapper,
  ResumeCounterWrapper,
  ResumeWrapper,
  ResumeTitle,
  ResumeValue
} from './MainFooter.styles'
import { MainFooterProps } from './MainFooter.types'
import useId from '../../hooks/useId'
import { productNotNullFields } from '../../../utils/validations'

const MainFooter = ({
  className = '',
  button,
  counter,
  styles,
  data,
  bundleData,
  text,
  hideCounterFields = [],
  product,
  onlyShowCounterOnDataReady = false,
  'data-testid': testid = 'main-footer',
  fullWidth = true,
  resumeData,
  isCounterOnTop = false,
  ...props
}: MainFooterProps) => {
  const { getTestId } = useId(testid)
  const isValidTextValue = !!text?.value
  const isValidBundle =
    bundleData && bundleData.isBundle && bundleData.counter && bundleData.button

  const counterConfig = isValidBundle ? bundleData?.counter : counter
  const buttonConfig = isValidBundle ? bundleData?.button : button
  const resumeDataConfig = isValidBundle ? bundleData?.resumeData : resumeData

  const notNullFields = productNotNullFields(hideCounterFields, product)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMainClick = (event: any) => {
    event.preventDefault()
    event.stopPropagation()

    if (button?.actions) {
      button.actions({ data })
    }
  }

  const counterLoading: boolean =
    onlyShowCounterOnDataReady && (!product?.id || !product?.name)

  const isValidResumeData =
    !!resumeDataConfig?.title && !!resumeDataConfig?.amount
  const isValidCounterData =
    !notNullFields && !!counterConfig && Object.keys(counterConfig).length > 0
  const isValidButtonData =
    !!buttonConfig && Object.keys(buttonConfig).length > 0
  const showCounterResume = isValidCounterData || isValidResumeData

  return (
    <MainFooterWrapper
      className={`MainFooter ${className}`}
      sx={styles}
      data-testid={getTestId()}
      {...props}>
      <CounterButtonWrapper
        fullWidth={fullWidth}
        isCounterOnTop={isCounterOnTop}>
        {showCounterResume && (
          <ResumeCounterWrapper>
            {isValidResumeData && (
              <ResumeWrapper>
                <ResumeTitle value={resumeDataConfig?.title} />
                <ResumeValue {...resumeDataConfig?.amount} />
              </ResumeWrapper>
            )}
            {isValidCounterData && (
              <FooterCounterWrapper
                data={data}
                data-testid={getTestId('counter')}
                loading={counterLoading}
                {...counterConfig}
              />
            )}
          </ResumeCounterWrapper>
        )}
        {isValidButtonData && (
          <MainFooterButton
            className="MainButton"
            data-testid={getTestId('button')}
            onClick={handleMainClick}
            {...buttonConfig}
          />
        )}
      </CounterButtonWrapper>
      {isValidTextValue && (
        <MainFooterText
          className="MainFooterText"
          data-testid={getTestId('text')}
          onClick={() => {
            text?.actions?.({ data })
          }}
          {...text}
        />
      )}
    </MainFooterWrapper>
  )
}

export default MainFooter
